import React from 'react'
// import React, { useState, useMemo } from 'react'
import PageLoader from 'components/PageLoader'
// import request from 'services/http'
// import { tap, finalize } from 'rxjs/operators'

export default function DetalhaValores({ field, empresa, dataInicial, dataFinal }) {

    // const [isFetching, setIsFetching] = useState(true)
    // const [dados, setDados] = useState(null)

    // const fetchData$ = useMemo(() => request({
    //     url: '/nfce/conferencia/detalhar',
    //     method: 'GET',
    //     params: {
    //         field,
    //         empresa,
    //         dataInicial,
    //         dataFinal
    //     }
    // }).pipe(
    //     tap(({ response }) => setDados(response)),
    //     finalize(() => setIsFetching(false))
    // ), [setDados, field, empresa, dataInicial, dataFinal])

    console.log(field)
    return (
        <PageLoader active={true} content='Buscando detalhes...'>
            <div>TESTE</div>
        </PageLoader>
    )
}
